import { GetOrderListResponse } from '../../../commons/kymw02/api-services/get-order-list.service';
import { KYMW1204OutputModel } from './vo/kymw1204-output.model';

/**
 * 一括設定画面の値を管理するクラス
 *
 * @export KYMW1204Model
 * @class KYMW1204Model
 */
export class KYMW1204Model {
  catalogMemo = '';

  copyCatalogMemoFlg = false;

  cycleFixedFlg = false;

  output: KYMW1204OutputModel;

}
